import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SiteService } from 'src/app/services/index';
import { ActionModeEnum, AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-add-node-info-modal',
  templateUrl: './add-node-info-modal.component.html',
  styleUrls: ['./add-node-info-modal.component.scss']
})
export class AddNodeInfoModalComponent implements OnInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  nodeType = Constants.NODE_TYPE;
  modalForm: any;
  formData: UntypedFormGroup;
  requiredValidators = [Validators.required];
  meters: any;
  processes: any;
  virtualGroupsConfiguredForSite: any;
  nodeInfoModalMode = ActionModeEnum.Viewing; // default
  selectedMetersRId = [];
  selectedProcessesRId = [];
  newNodeIdInc = 0;
  title = '';
  level = -1;
  constructor(
    public dialogRef: MatDialogRef<AddNodeInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private cdRef: ChangeDetectorRef,
    private alertService: AlertService,
    private fb: UntypedFormBuilder
  ) {
    this.meters = data.meters;
    this.processes = data.processes;
    this.virtualGroupsConfiguredForSite = data.virtualGroupsConfiguredForSite;
    this.selectedMetersRId = data.selectedMetersRId;
    this.selectedProcessesRId = data.selectedProcessesRId;
    this.nodeInfoModalMode = data.actionMode;
    if (data.nodeData !== undefined) {
      this.level = data.nodeData.level;
    }

    this.formData = this.fb.group({
      rdNoteTitleCtr: [''],
      nodeTitleCtr: [''],
      selectedMeterCtr: [''],
      selectedProcessCtr: [''],
      selectedVirtualGroupCtr: ['']
    });
    this.modalForm = {};
    switch (this.nodeInfoModalMode) {
      case ActionModeEnum.Editing:
        this.title = 'Modify Node';
        this.modalForm = data.modalForm;
        this.changeNodeType(ActionModeEnum.Editing);
        break;
      case ActionModeEnum.Creating:
        this.title = 'Add Node';
        this.modalForm.nodeType = this.nodeType.TEXT;
        this.modalForm.nodeData = data.nodeData;
        this.changeNodeType(ActionModeEnum.Creating);
        break;
      default:
        this.clearValidator();
        break;
    }
  }

  ngOnInit() {}

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };

  public close = (confirm: boolean) => {
    this.dialogRef.close({ status: confirm, data: null });
  };

  public changeNodeType = (actionMode = ActionModeEnum.Creating) => {
    this.clearValidator();
    switch (this.modalForm.nodeType) {
      case 'TEXT': {
        const nodeTitleCtr = this.formData.get('nodeTitleCtr');
        const opt = [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ];
        nodeTitleCtr.setValidators(opt);
        nodeTitleCtr.enable();
        if (actionMode === ActionModeEnum.Editing) {
          nodeTitleCtr.setValue(this.modalForm.nodeName);
        }
        nodeTitleCtr.updateValueAndValidity();
        break;
      }
      case 'METER': {
        const selectedMeterCtr = this.formData.get('selectedMeterCtr');
        selectedMeterCtr.enable();
        if (actionMode === ActionModeEnum.Editing) {
          // eslint-disable-next-line eqeqeq
          const index = Array.from(this.meters).findIndex(
            (v: any) => v.meterId == this.modalForm.meterId
          );
          if (index >= 0) {
            this.modalForm.selectedMeter = this.meters[index];
            selectedMeterCtr.setValue(this.modalForm.selectedMeter);
          }
        }
        selectedMeterCtr.setValidators(this.requiredValidators);
        selectedMeterCtr.updateValueAndValidity();
        break;
      }
      case 'PROCESS': {
        const selectedProcessCtr = this.formData.get('selectedProcessCtr');
        selectedProcessCtr.enable();
        if (actionMode === ActionModeEnum.Editing) {
          for (let i = 0; i < this.processes.length; i++) {
            if (this.processes[i].rId === this.modalForm.processRId) {
              this.modalForm.selectedProcess = this.processes[i];
              selectedProcessCtr.setValue(this.modalForm.selectedProcess);
              break;
            }
          }
        }
        selectedProcessCtr.setValidators(this.requiredValidators);
        selectedProcessCtr.updateValueAndValidity();
        break;
      }
      case 'VIRTUAL_GROUP': {
        const selectedVirtualGroupCtr = this.formData.get(
          'selectedVirtualGroupCtr'
        );
        selectedVirtualGroupCtr.enable();
        if (actionMode === ActionModeEnum.Editing) {
          selectedVirtualGroupCtr.setValue(this.modalForm.selectedVirtualGroup);
        }
        selectedVirtualGroupCtr.setValidators(this.requiredValidators);
        selectedVirtualGroupCtr.updateValueAndValidity();
        break;
      }
      default: {
        const nodeTitleCtr = this.formData.get('nodeTitleCtr');
        const opt = [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30)
        ];
        nodeTitleCtr.setValidators(opt);
        nodeTitleCtr.enable();
        nodeTitleCtr.updateValueAndValidity();
        break;
      }
    }
  };

  private clearValidator = () => {
    const nodeTitleCtr = this.formData.get('nodeTitleCtr');
    nodeTitleCtr.setValidators(null);
    nodeTitleCtr.disable();
    nodeTitleCtr.setValue(null);
    nodeTitleCtr.updateValueAndValidity();
    //
    const selectedMeterCtr = this.formData.get('selectedMeterCtr');
    selectedMeterCtr.setValidators(null);
    selectedMeterCtr.disable();
    selectedMeterCtr.setValue(null);
    selectedMeterCtr.updateValueAndValidity();
    //
    const selectedProcessCtr = this.formData.get('selectedProcessCtr');
    selectedProcessCtr.setValidators(null);
    selectedProcessCtr.disable();
    selectedProcessCtr.setValue(null);
    selectedProcessCtr.updateValueAndValidity();
    //
    const selectedVirtualGroupCtr = this.formData.get(
      'selectedVirtualGroupCtr'
    );
    selectedVirtualGroupCtr.setValidators(null);
    selectedVirtualGroupCtr.disable();
    selectedVirtualGroupCtr.setValue(null);
    selectedVirtualGroupCtr.updateValueAndValidity();
  };

  public saveNode = () => {
    let nodeData = this.modalForm.nodeData;
    const hasAttachment = this.modalForm.hasAttachment;
    let nodeTitle: any;
    let meter: any;
    let process: any;
    let childrenNodes = [];
    let load: any;
    switch (this.modalForm.nodeType) {
      case 'TEXT': {
        nodeTitle = this.modalForm.nodeName;
        break;
      }
      case 'PROCESS': {
        nodeTitle = this.modalForm.selectedProcess.name;
        process = this.modalForm.selectedProcess;
        break;
      }
      case 'VIRTUAL_GROUP': {
        nodeTitle = this.modalForm.selectedVirtualGroup;
        break;
      }
      case 'METER': {
        nodeTitle = this.modalForm.selectedMeter.meterId;
        meter = this.modalForm.selectedMeter;
        if (this.processes !== undefined) {
          for (let i = 0; i < this.processes.length; i++) {
            for (let j = 0; j < this.processes[i].loads.length; j++) {
              if (
                this.processes[i].loads[j].meter !== undefined &&
                this.processes[i].loads[j].meter !== null &&
                this.processes[i].loads[j].meter.rId === meter.rId
              ) {
                load = this.processes[i].loads[j];
                break;
              }
            }
            if (load !== undefined && load.loadId !== undefined) {
              break;
            }
          }
        }
        break;
      }
      default: {
        break;
      }
    }
    switch (this.nodeInfoModalMode) {
      case ActionModeEnum.Creating:
        let meterRId: any;
        let meterId: any;
        let meterRole: any;
        let processRId: any;
        if (meter !== undefined) {
          if (meter.rId !== undefined) {
            this.selectedMetersRId.push(meter.rId);
            meterRId = meter.rId;
          }
          if (meter.meterId !== undefined) {
            meterId = meter.meterId;
          }
          if (meter.meterRole !== undefined) {
            meterRole = meter.meterRole;
          }
        }
        if (process !== undefined && process.rId !== undefined) {
          this.selectedProcessesRId.push(process.rId);
          processRId = process.rId;
          childrenNodes = this.generateLoadLeavesForProcessBranch(process);
        }
        if (nodeData.nodes === undefined) {
          nodeData.nodes = [];
        }
        nodeData.nodes.push({
          nodeId: this.generateStaticNodeId(),
          title: nodeTitle,
          nodes: childrenNodes,
          meterRId: meterRId,
          processRId: processRId,
          meterId: meterId,
          meterRole: meterRole,
          nodeType: this.modalForm.nodeType,
          loadName: load !== undefined ? load.name : undefined,
          loadId: load !== undefined ? load.loadId : undefined,
          hasAttachment: hasAttachment
        });
        break;
      case ActionModeEnum.Editing:
        if (
          meter !== undefined &&
          nodeData.meterRId !== undefined &&
          nodeData.meterRId !== meter.rId
        ) {
          for (let i = 0; i < this.selectedMetersRId.length; i++) {
            if (this.selectedMetersRId[i] === nodeData.meterRId) {
              this.selectedMetersRId.splice(i, 1);
              break;
            }
          }
        } else if (
          process !== undefined &&
          nodeData.processRId !== undefined &&
          nodeData.processRId !== process.rId
        ) {
          for (let i = 0; i < this.selectedProcessesRId.length; i++) {
            if (this.selectedProcessesRId[i] === nodeData.processRId) {
              this.selectedProcessesRId.splice(i, 1);
              break;
            }
          }
        }
        if (
          meter !== undefined &&
          meter.rId !== undefined &&
          nodeData.meterRId !== meter.rId
        ) {
          this.selectedMetersRId.push(meter.rId);
        } else if (
          process !== undefined &&
          process.rId !== undefined &&
          nodeData.processRId !== process.rId
        ) {
          this.selectedProcessesRId.push(process.rId);
          childrenNodes = this.generateLoadLeavesForProcessBranch(process);
          nodeData.nodes = childrenNodes;
        }
        nodeData.title = nodeTitle;
        nodeData.meterRId = meter !== undefined ? meter.rId : undefined;
        nodeData.processRId = process !== undefined ? process.rId : undefined;
        nodeData.meterId = meter !== undefined ? meter.meterId : undefined;
        nodeData.meterRole = meter !== undefined ? meter.meterRole : undefined;
        nodeData.nodeType = this.modalForm.nodeType;
        nodeData.loadName = load !== undefined ? load.name : undefined;
        nodeData.loadId = load !== undefined ? load.loadId : undefined;
        nodeData.hasAttachment = hasAttachment;
        break;
      case ActionModeEnum.CreatingFirstLevel:
        if (meter !== undefined && meter.rId !== undefined) {
          this.selectedMetersRId.push(meter.rId);
        }
        if (process !== undefined && process.rId !== undefined) {
          this.selectedProcessesRId.push(process.rId);
          childrenNodes = this.generateLoadLeavesForProcessBranch(process);
        }
        const newTreeData = [
          {
            nodeId: this.generateStaticNodeId(),
            title: nodeTitle,
            nodes: childrenNodes,
            meterRId: meter !== undefined ? meter.rId : undefined,
            processRId: process !== undefined ? process.rId : undefined,
            meterId: meter !== undefined ? meter.meterId : undefined,
            meterRole: meter !== undefined ? meter.meterRole : undefined,
            nodeType: this.modalForm.nodeType,
            loadName: load !== undefined ? load.name : undefined,
            loadId: load !== undefined ? load.loadId : undefined,
            hasAttachment: hasAttachment
          }
        ];
        nodeData = newTreeData;
        break;
      default:
        break;
    }
    const value = {
      nodeData: nodeData,
      selectedMetersRId: this.selectedMetersRId,
      selectedProcessesRId: this.selectedProcessesRId
    };
    this.siteService.sendNodeInfoSubject(value);
    this.close(false);
  };

  private generateLoadLeavesForProcessBranch = (processData: any) => {
    const nodes = [];
    for (let i = 0; i < processData.loads.length; i++) {
      const load = processData.loads[i];
      let meterId: any, meterRole: any, meterRId: any;
      if (load.meter != null) {
        meterId = load.meter.meterId;
        meterRole = load.meter.meterRole;
        meterRId = load.meter.rId;
      }
      nodes.push({
        nodeId: this.generateStaticNodeId(),
        title: load.name,
        nodes: [],
        meterRId: meterRId,
        processRId: undefined,
        loadRId: load.rId,
        meterId: meterId,
        loadId: load.loadId,
        kwRating: load.kwRating,
        type: load.type,
        subType: load.subType,
        meterRole: meterRole,
        nodeType: this.nodeType.LOAD,
        loadName: load.name
      });
    }
    return nodes;
  };

  generateStaticNodeId() {
    let result = 'level' + (this.level + 1) + 'table_';
    let timeStamp = Date.now();
    let randomNumber = Math.floor(Math.random() * 1000);

    return result + timeStamp + '_' + randomNumber;
  }

  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
}
